import { Box } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import 'dayjs/locale/sr';
import 'dayjs/locale/de';

import InputLabel from 'components/input-label';
import classes from './index.module.css';
import i18n from 'config/localization';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
dayjs.extend(customParseFormat);


const CustomDatePicker = ({
  label,
  required,
  ...props
}: any) => {
  const languageFromI18n = i18n.language.toLowerCase().split('-')[0] as 'EN' | 'DE' | 'SR' | 'AL' | 'ES' | 'FR' | 'IT' | 'PT' | 'TR';

  const parseDate = (value: string) => {
    const formats = ['DD.MM.YYYY', 'D.M.YYYY', 'DD.M.YYYY', 'D.MM.YYYY'];
    for (const format of formats) {
      if (dayjs(value, format, true).isValid()) {
        return dayjs(value, format).toDate();
      }
    }
    return null;
  };

  return (
    <Box mb={6}>
      {label ? <InputLabel label={label} required={required} /> : undefined}
      <DateInput
        classNames={{ input: classes.input }}
        withAsterisk={props.required}
        clearable={true}
        inputWrapperOrder={['label', 'input', 'error', 'description']}
        locale={languageFromI18n}
        valueFormat={'DD.MM.YYYY'}
        dateParser={(value) => parseDate(value)}
        {...props}
      />
    </Box>
)
};

export default CustomDatePicker;